// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "insurance-2mpwf";
var _5 = "selected-2KTE9";
var _6 = "insurance__header-K6lAT";
var _7 = "insurance__money--JB1_";
var _8 = "insurance__content-17U5z";
var _9 = "options-2UEKt";
var _a = "option-P6Zzr";
var _b = "insurance__button-1koyT";
var _c = "insurance__button_selected-F-nsO";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "insurance", _5 as "selected", _6 as "insurance__header", _7 as "insurance__money", _8 as "insurance__content", _9 as "options", _a as "option", _b as "insurance__button", _c as "insurance__button_selected" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "insurance": _4, "selected": _5, "insurance__header": _6, "insurance__money": _7, "insurance__content": _8, "options": _9, "option": _a, "insurance__button": _b, "insurance__button_selected": _c }
